import type { ITextLaborIllusionText } from "./text-labor-illusion.interface";

export const TEXT_LABOR_ILLUSION_ID = "text-labor-illusion";

export const CHATBOT_LABOR_ILLUSION_MESSAGES: ITextLaborIllusionText[] = [
  {
    message: "Analizzando la tua domanda...",
    minDurationInMilliseconds: 5000,
    maxDurationInMilliseconds: 8000,
  },
  {
    message: "Cercando fonti rilevanti...",
    minDurationInMilliseconds: 5000,
    maxDurationInMilliseconds: 8000,
  },
  {
    message: "Semplificando termini complessi...",
    minDurationInMilliseconds: 5000,
    maxDurationInMilliseconds: 8000,
  },
];
